import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";
import { Icon, PlainButton } from "@culturehq/components";

import { CreatomateContext } from "../../contexts/VideoStudioContext";

interface PlayPauseButtonProps {
  preview?: Preview;
}

const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({ preview }) => {
  const { data: { isPlaying } } = useContext(CreatomateContext);

  const handlePlay = () => {
    if (!preview) return;
    preview.play();
  };

  const handlePause = () => {
    if (!preview) return;
    preview.pause();
  };

  if (isPlaying) {
    return (
      <PlainButton
        className="Btn-Play"
        onClick={handlePause}
      >
        <Icon icon="pause-no-bg" />
      </PlainButton>
    );
  }

  return (
    <PlainButton
      className="Btn-Play"
      onClick={handlePlay}
    >
      <Icon icon="play-no-border" />
    </PlainButton>
  );
};

export default PlayPauseButton;
